import React from "react";
import {Helmet} from "react-helmet";
import Arch6 from "../../assets/images/arch/arch-6.png";
import Arch1 from "../../assets/images/arch/arch-1.png";
import Arch2 from "../../assets/images/arch/arch-2.png";
import Arch3 from "../../assets/images/arch/arch-3.png";
import Arch4 from "../../assets/images/arch/arch-4.png";
import Arch5 from "../../assets/images/arch/arch-5.png";
import Arch7 from "../../assets/images/arch/arch-7.png";

export default function BatAndHorse() {
    return (
        <div>
            <Helmet>
                <title>枓栱之方 Brackets Conference Room</title>
            </Helmet>
            <h6 className="App-essay-title">枓栱之方</h6>
            <p className="App-essay-article">
                <br/>
                <b>二〇二五 五月</b>
                <br/><br/>
                十年前，我在清华大学建筑系，与两位同学，在一位性格强烈的美国教授指导下，盖了我们人生中第一栋建成物：一个灵感取自中国古典建筑“枓栱”的木构会议室。这是我在本科时代干过最痛苦的事。
                <br/><br/>
                如果大家今天去清华建筑系新馆，在二楼的中庭，还能看到我们设计的，一个用松木、桦木、胶合板、钢化玻璃、花岗岩和304不锈钢，亲手建造成的构筑物。
                <br/><br/>
                如果大家不好想象这个过程，和那一年半的设计和建造经历有多痛苦，请把爆裂鼓手看十遍，大概就是这个感觉。
                <br/><br/>
                从MIT毕业之后，我去世界银行工作，疫情爆发，回国去了腾讯。我很少评论建筑行业，因为脱离了建筑师和一线实践，我没有资格像那些还在一线作战的建筑师老朋友一样，评论原子世界如何运作。因为“没有调查，就没有发言权”——毛泽东。物质世界比信息世界更复杂。
                <br/><br/>
                从十年前开始计算，实践对我的教训远超任何抽象“理论”带来的自负和傲慢。我离开那个唯我独尊的名校蠢货已经十周年了。我手腕上的表还在走，我准备让它复利叠加。
                <br/><br/>
                let it compound⌛️
                <br/><br/>

                <img src={Arch6} alt="" width={"100%"}/> <br/><br/>
                <img src={Arch3} alt="" width={"100%"}/> <br/><br/>
                <img src={Arch2} alt="" width={"100%"}/> <br/><br/>
                <img src={Arch1} alt="" width={"100%"}/> <br/><br/>
                <img src={Arch5} alt="" width={"100%"}/> <br/><br/>
                <img src={Arch4} alt="" width={"100%"}/> <br/><br/>
                <img src={Arch7} alt="" width={"100%"}/> <br/><br/>
                <i style={{color: "grey"}}>清华大学建筑系，新馆二层中庭，永久保存。</i> <br/><br/>

                <b>Reference</b>
                <br/>
                1. <a href="https://mp.weixin.qq.com/s/VRrjhYk5OqGcCnOwo-yrcg" rel="noreferrer noopener" target="_blank">WA | 设计实验奖佳作奖：枓栱之方 | 2016WA中国建筑奖</a>

            </p>

            <br/>

            <h6 className="App-essay-title">Brackets Conference Room</h6>
            <p className="App-essay-article">
                <br/>
                <b>May 2025</b>
                <br/><br/>

            </p>
        </div>)
}
